module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/insulated-containers-20f460f4cb0615d1083c49b8c81e4cb7.png";